__turbopack_context__.v({
  "accountCards": "CardIcon-module-scss-module__KtQjnG__accountCards",
  "mastercard": "CardIcon-module-scss-module__KtQjnG__mastercard",
  "svg": "CardIcon-module-scss-module__KtQjnG__svg",
  "visa": "CardIcon-module-scss-module__KtQjnG__visa",
});
